<template>
  <Wrapper @openEditor="$emit('openEditor')">
    <div class="full-text-container">
      <div class="title" :class="!title && 'no-wrapper'">
        <div class="title-text module-text-title" ref="titleEl">{{ title }}</div>
        <div class="under-line" :style="titleUnderLineStyle">
          <el-divider v-if="hasTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="sub-title" :class="!subTitle && 'no-wrapper'">
        <div class="sub-title-text module-text-subtitle" ref="subTitleEl">{{ subTitle }}</div>
        <div class="under-line" :style="subTitleUnderLineStyle">
          <el-divider v-if="hasSubTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="content">
        <div class="content-text ql-editor module-text-content" ref="contentEl" v-html="checkedContentHtml"></div>
        <div class="under-line" :style="contentUnderLineStyle">
          <el-divider v-if="hasContentUnderLine"></el-divider>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from '../../components/render/wrapper'
import { mapGetters } from 'vuex'

export default {
  components: {
    Wrapper
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    underLine: {
      type: Object,
      required: false
    },
    styleConfig: {
      type: Object,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'currentPage']),
    checkedContentHtml () {
      return this.checkContent(this.content)
    },
    hasTitleUnderLine () {
      return this.underLine && this.underLine.title && this.underLine.title.isShow
    },
    hasSubTitleUnderLine () {
      return this.underLine && this.underLine.subTitle && this.underLine.subTitle.isShow
    },
    hasContentUnderLine () {
      return this.underLine && this.underLine.content && this.underLine.content.isShow
    },
    titleUnderLineStyle () {
      return this.formatUnderLineStyle('title', this.underLine.title)
    },
    subTitleUnderLineStyle () {
      return this.formatUnderLineStyle('subTitle', this.underLine.subTitle)
    },
    contentUnderLineStyle () {
      return this.formatUnderLineStyle('content', this.underLine.content)
    }
  },
  created () {

  },
  methods: {
    checkContent (content) {
      // to-do may need to check some danger html code
      return content
    },
    formatUnderLineStyle (type, config, isSelfTigger) {
      let width = config.width
      let el = null
      if (this.$refs) {
        if (type === 'title') {
          el = this.$refs.titleEl
        } else if (type === 'subTitle') {
          el = this.$refs.subTitleEl
        } else if (type === 'content') {
          el = this.$refs.contentEl
        }
      }
      if (el) {
        if (!width || width === 'full') {
          width = '100%'
        } else if (!isNaN(width)) {
          width = width + 'px'
        } else if (width === 'compute') {
          width = (el.clientWidth + 60) + 'px'
        }
        const underLineEl = el.nextElementSibling.firstElementChild
        if (underLineEl) {
          const style = underLineEl.style
          style.width = width
          style.backgroundColor = config.color || '#DCDFE6'
        }
      } else if (!isSelfTigger) {
        this.$nextTick(() => this.formatUnderLineStyle(type, config, true))
      }
      return { }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .full-text-container {
    text-align: center;
    margin: 35px 0;

    .under-line {
      width: 100%;

      .el-divider {
        margin: 0 auto;
      }
    }

    .title, .sub-title {
      margin-bottom: 20px;
    }

    .title-text, .sub-title-text {
      display: inline-block;
    }

    .sub-title-text {
      padding: 0 15px;
    }

    .content-text {
      padding: 0;
    }
  }
}
.site-mobile {
  .full-text-container {
    padding: 0 10px;

    .title {
      padding-bottom: 1px;

      .under-line {
        margin-top: 10px;
      }
    }
  }
}
.site-pc {
  .full-text-container {
    width: 1080px;
    margin: 0 auto;

    .title {
      .under-line {
        margin-top: 20px;
      }
    }
  }
}
</style>
